import { useMemo } from 'react';

export interface BackstagePageQueries {
  backstageAllLogsQuery: any;
  backstageErrorLogsQuery: any;
  backstageTopErrorLogsQuery: any;
}

export const useBackstageQueryBuilder = (
  selectedDataSource: string | null,
  timeRange: string,
): BackstagePageQueries => {
  return useMemo(() => {
    let from: string;
    let to: string;

    if (timeRange.startsWith('custom:')) {
      const [startDate, endDate] = timeRange.replace('custom:', '').split('|');
      from = startDate;
      to = endDate;
    } else {
      from = `now-${timeRange}`;
      to = 'now';
    }

    const backstageAllLogsQuery = {
      datasourceUid: selectedDataSource,
      queries: [
        {
          refId: 'A',
          expr: '{app="backstage"}',
          queryType: 'range',
          legendFormat: 'Backstage Logs',
          limit: 1000,
        },
      ],
      range: { from, to },
      interval: '60000',
    };

    const backstageErrorLogsQuery = {
      datasourceUid: selectedDataSource,
      queries: [
        {
          refId: 'A',
          expr: '{app="backstage"} |~ "(?i)error"',
          queryType: 'range',
          legendFormat: 'Backstage Erros',
          limit: 500,
        },
      ],
      range: { from, to },
      interval: '60000',
    };

    const backstageTopErrorLogsQuery = {
      datasourceUid: selectedDataSource,
      queries: [
        {
          refId: 'A',
          expr: '{app="backstage"} |~ "(?i)error"',
          queryType: 'range',
          legendFormat: 'Top Erros Backstage',
          limit: 500,
        },
      ],
      range: { from, to },
      interval: '60000',
    };

    return {
      backstageAllLogsQuery,
      backstageErrorLogsQuery,
      backstageTopErrorLogsQuery,
    };
  }, [selectedDataSource, timeRange]);
};
